const InvestorsRedirect = () => {
  const investorRoomUrl = process.env.REACT_APP_INVESTOR_ROOM_URL || "https://investor-room.emergent.host/";
  
  return (
    <div className="w-full h-screen">
      <iframe
        src={investorRoomUrl}
        title="Investor Room"
        className="w-full h-full border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

export default InvestorsRedirect;
